// @ts-strict-ignore
import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SNACK_STATES = {
  normal: "normal",
  loading: "loading",
  success: "success",
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SNACK_POSITIONS = {
  topLeft: "topLeft",
  topRight: "topRight",
  bottomLeft: "bottomLeft",
  bottomRight: "bottomRight",
};

export type SnackType = keyof typeof SNACK_STATES;
export type SnackPosition = keyof typeof SNACK_POSITIONS;

/**
 * @deprecated Use Snackbar from @fullscript/aviary-web instead
 */
interface LegacySnackbarData {
  isSnackbarOpen: boolean;
  message: string;
  status: string;
  position: SnackPosition;
  closeSnack: (message: string) => void;
  setSnackMessage: (status: SnackType, message: string, position?: SnackPosition) => void;
}

/**
 * @deprecated Use Snackbar from @fullscript/aviary-web instead
 */
const LegacySnackbarContext = createContext<LegacySnackbarData>(null);

export type { LegacySnackbarData };
export { LegacySnackbarContext };
